// api client
import apiClient from './apiClient.js'

const REQUESTS = {
  index: () => {
    return `query {
      roles
    }`   
  }
}

export const rolesApi = {
  index: async (next) => {
    const result = await apiClient.req(REQUESTS.index())
    next(result.data.data.roles)
  }
}
